<template>
  <div>
    <v-card flat class="mx-4 mt-4 rounded-20">
      <v-card-title class="title-font"> ORDER INVOICE HISTORY </v-card-title>
    </v-card>
    <v-card flat class="mx-4 mt-4 rounded-20">
      <v-card-text v-if="loading" class="text-center">
        <v-progress-circular indeterminate color="primary" />
      </v-card-text>
      <v-data-table
        :headers="headers"
        :items="_invoices || []"
        :items-per-page="5"
        v-if="!loading"
      >
        <template v-slot:[`header.invoice_number`]="{ header }">
          {{ header.text }}
          <v-tooltip top class="rounded-10">
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="ml-1 pb-1" v-bind="attrs" v-on="on">
                mdi-cursor-default-click
              </v-icon>
            </template>
            <span> Click ID to view Invoice Details. </span>
          </v-tooltip>
        </template>
        <template v-slot:[`header.url`]="{ header }">
          {{ header.text }}
          <v-tooltip top class="rounded-10">
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="ml-1 pb-1" v-bind="attrs" v-on="on">
                mdi-information
              </v-icon>
            </template>
            <span>
              Open to view payment details, download invoice and receipt.
            </span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.invoice_number`]="{ item }">
          <div style="white-space: nowrap">
            <v-tooltip top class="rounded-10" v-if="item.order_uid">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  small
                  v-bind="attrs"
                  v-on="on"
                  class="ml-n1 px-1"
                  @click="openDetail(item)"
                >
                  {{ item.invoice_number }}
                </v-btn>
              </template>
              <span> Click to view details. </span>
            </v-tooltip>
            <v-tooltip top class="rounded-10" v-if="item.order_uid">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-if="!item.paid"
                  color="warning"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-alert
                </v-icon>
              </template>
              <span> This invoice has not been paid. </span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:[`item.invoiced_at`]="{ item }">
          {{ item.invoiced_at | luxon({ output: "date_short" }) }}
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          $ {{ item.amount }}
        </template>
        <template v-slot:[`item.pdf`]="{ item }">
          <a :href="item.pdf">PDF</a>
        </template>
        <template v-slot:[`item.url`]="{ item }">
          <a :href="item.url" target="_blank">Open Payment Page</a>
          <v-icon class="ml-1 pb-2" color="primary" x-small>
            mdi-open-in-new
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <InvoiceDetailDialog v-model="dialog" :invoice="selectedInvoice" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex"
import InvoiceDetailDialog from "@/components/shared/InvoiceDetailDialog.vue"

export default {
  name: "InvoiceHistory",

  components: { InvoiceDetailDialog },

  data() {
    return {
      loading: false,
      dialog: false,
      selectedInvoice: null,
      headers: [
        {
          text: "Invoice ID",
          value: "invoice_number"
        },
        {
          text: "Issued",
          value: "invoiced_at"
        },
        {
          text: "Amount (ex. Tax)",
          value: "amount"
        },
        {
          text: "Download (PDF)",
          value: "pdf"
        },
        {
          text: "Payment Page",
          value: "url"
        }
      ]
    }
  },

  watch: {
    invoices(val) {
      if (val) this.loading = false
    },

    dialog(val) {
      if (!val) this.selectedInvoice = null
    }
  },

  computed: {
    ...mapGetters(["invoices", "inArrears", "inboxItems", "selectedOrder"]),
    _invoices() {
      return this.invoices.filter((i) => i.order_uid === this.selectedOrder.uid)
    }
  },

  methods: {
    ...mapActions(["triggerReload", "setSelectedOrder"]),

    openDetail(invoiceItem) {
      this.selectedInvoice = invoiceItem
      this.dialog = true
    }
  },

  mounted() {
    this.loading = true
    if (this.invoices) this.loading = false
    else this.triggerReload("invoices")
  }
}
</script>
